import axios from 'axios'

export default {
    namespaced: true,

    state: {
       selectedFormClass: null, 
       selectedStudent: null, 
       studentSubjectAssignment: {},          
    },

    getters: {
        getSelectedFormClass: state => state.selectedFormClass,

        getStudentSelected: state => state.selectedStudent,

        getStudentSubjectAssignment: state => state.studentSubjectAssignment
    },

    mutations: {
        setSelectedFormClass(state, value) {
            state.selectedFormClass = value
        },

        setSelectedStudent(state, value) {
            state.selectedStudent = value
        },

        setStudentSubjectAssignment(state, value) {
            state.studentSubjectAssignment = value
        }
    },

    actions: {
        getFormClasses(){
           const url = '/api/csec-subject-selection/form-classes'
           return axios.get(url)
       },

       getStudents() {
           const url = '/api/csec-subject-selection/students'
           return axios.get(url, {params: {form_class_id: this.state.csecSubjectSelection.selectedFormClass}})
       },

       getSubjectGroups() {
           const url = '/api/csec-subject-selection-groups'
           return axios.get(url)
       },

       getStudentSubjectChoices({ getters }) {
           const url = '/api/csec-subject-choice'
           return axios.get(url, {params: {student_id: getters.getStudentSelected.student_id}})
       },

       getStudentSubjectAssignment({ getters }) {
           const url = '/api/csec-subject-selection/student-assignment'
           return axios.get(url, {params: {student_id: getters.getStudentSelected.student_id}})
       },

       postStudentSubjectAssignment({ getters}) {
           const url = '/api/csec-subject-selection/student-assignment'
           return axios.post(url, {
               student_id: getters.getStudentSelected.student_id,
               group_1: getters.getStudentSubjectAssignment[1],
               group_2: getters.getStudentSubjectAssignment[2],
               group_3: getters.getStudentSubjectAssignment[3],
               group_4: getters.getStudentSubjectAssignment[4],
               group_5: getters.getStudentSubjectAssignment[5],
           })
       }

    }
}